import { render, staticRenderFns } from "./WhatsappGroups.vue?vue&type=template&id=cb2d5210"
import script from "./WhatsappGroups.vue?vue&type=script&lang=js"
export * from "./WhatsappGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports